import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  StandingAuthorizationsRequest,
  StandingAuthorizationsResponse,
} from '../models/Standing-Authorizations';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';

@Injectable({
  providedIn: 'root',
})
export class StandingAuthorizationsService {
  standingAuthorizationsPath: string = 'api/ria.MoneyMovementExperience';

  constructor(
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) {}

  callStandingAuthorizations(
    requestData: StandingAuthorizationsRequest
  ): Observable<StandingAuthorizationsResponse> {
    const url = `${this.integrationService.JfkEnv.BaseUrl}${
      this.standingAuthorizationsPath
    }/v1/standing-authorizations?${encodeURIComponent(
      'filter[transactionType]'
    )}=${requestData.sloaType}&master=${encodeURIComponent(
      '$master'
    )}&accountNumber=${encodeURIComponent('$accountNumber')}`;

    // TODO: update environment with env variable once set up
    let headers = this.getHeadersWithClientIds(
      `master=${requestData.masterAccountId},accountNumber=${requestData.subAccountId}`
    );

    return this.baseService.get<StandingAuthorizationsResponse>(url,headers,false);
  }

  public getHeadersWithClientIds(clientIds: string): {
    [name: string]: string;
  } {
    var headers = this.headersService.createHeadersNotJsonApi('1');
    headers['Schwab-Client-Ids'] = clientIds;
    return headers;
  }
}
